import React from "react";
import Navbar from "../../Navbar/Navbar";
import ProjectItem from "./ProjectItem/ProjectItem";
import projects from "../../../utils/projects";
const Projects = () => {
	return (
		<>
			<Navbar />
			<div className="projects-container">
				<div className="projects-items scroll">
					{projects.map((project, index) => (
						<ProjectItem className="project-item" key={index} {...project} />
					))}
				</div>
			</div>
		</>
	);
};

export default Projects;
